<template>
    <div class="stress-tag">
        <!-- Alert Tag 警報標籤按鈕 @click="alert.showModel=true"-->
        <b-button type="button"
                  :class="getStressBtnClass()"
                  v-b-modal="modalID"
                  v-html="getStressBtnText()">
        </b-button>



        <!-- Alert Content 警報內容 -->
        <b-modal hide-header-close ok-only size="md"
            :id="modalID" ref="modal"
            v-if="showAlertModal('Normal')"
            header-text-variant="light"
            :header-class="'stress-default stress_' + alert.status_code" >
            <!-- header -->
            <div slot="modal-header" v-html="getAlertModelTitle(alert)"></div>

            <!-- 裝置資訊 -->
            <!-- <i class="fa fa-magic"></i>{{ $t('menu.warning_history') }}<br> -->

            <!-- 預警歷史紀錄 -->
            <div class="stress-history-title">{{ $t('menu.warning_history') }}</div>
            <div class="stress-history-count">{{ alert.log_info.length }}</div>
            <div class="stress-history-range"><i class="icon-clock"></i>{{ $t('menu.range') }}： {{ queryHours }} {{ $t('u.hours') }}</div>
            <br>
            <div class="stress-history-area">
                <div v-for="(info, idx_info) in alert.log_info" :key="idx_info" class="stress-history">
                    <div class="stress-history-idx">{{ idx_info + 1 }}</div>
                    <div class="stress-history-time">{{ info.log_time }}</div>
                    <div class="stress-history-device-id list-edit-area-button-sm"
                         v-if="user_admin"
                         @click="goToPage('project', { projectID: projID, cropperiodID: cpID }, info.device)">
                        {{ info.device }}
                    </div>
                    <div class="stress-history-device-name list-edit-area-button-sm"
                         @click="goToPage('project', { projectID: projID, cropperiodID: cpID }, info.device)">
                        {{ info.name }}
                        <div class="list-edit-area-hover"><i class="fa fa-dashboard"></i></div>
                    </div>
                </div>
            </div>

            <!-- 防治建議 -->
            <div v-if="alert.work && alert.work.length > 0">
                
                <div class="stress-history-title text-muted"><i class="fa fa-ambulance"></i>{{ $t('menu.suggested_preventions') }}</div>
                <div class="stress-prevention-area">
                    <div v-for="(work, idx_w) in alert.work" :key="idx_w">

                        <!-- 先隱藏不顯示圖片 -->
                        
                        <!-- <b-row v-if="work.url" class="stress-prevention-work">
                            <b-col md="8" sm="7">
                                <div class="stress-prevention-idx"># {{ idx_w + 1 }}.</div>
                                <div class="stress-prevention-text">{{ work.management }}</div>
                            </b-col>
                            <b-col md="4" sm="5" cols="8">
                                <b-img class="clickable-img" thumbnail fluid
                                        :src="work.url" :alt="work.management"
                                        @click="$tools.ui.openNewPage(work.url)"></b-img>
                            </b-col>
                        </b-row> -->
                        <!-- <div v-else class="stress-prevention-work"> -->
                        <div class="stress-prevention-work">
                                <div class="stress-prevention-idx"># {{ idx_w + 1 }}.</div>
                                <div class="stress-prevention-text">{{ work.management }}</div>
                        </div>
                        <hr class="stress-prevention-work-dividing-line">
                    </div>
                </div>
            </div>
            

            <b-button v-if="linkToDashboard" class="btn-cp" :to="$config.getPagesURL('project', { projectID: projID, cropperiodID: cpID })">
                <i class="fa fa-dashboard"></i>{{ $t('menu.check_dashboard') }}
            </b-button>
            <br>
            <!-- <b-button class="btn-cp" :to="$config.getPagesURL('report', { projectID: projID, cropperiodID: cpID })">
                <i class="icon-book-open"></i>{{ $t('menu.agri_science_reports') }}
            </b-button> -->

            <div slot="modal-footer" class="w-100">
                <div class="float-left">
                    <!-- HashTag -->
                    <i class="fa fa-hashtag"></i>
                    <div class="sensor-hashtag">{{ getCropperiodName() }}
                        <div class="hashtag" v-if="alert.device">, {{ alert.name }} {{ alert.device }}</div>
                    </div>
                    
                </div>
                
                <b-btn size="md" :class="'btn-agri float-right btn-stress-' + alert.status_code" @click="closeModal()">
                {{ $t('menu.close') }}
                </b-btn>
            </div>
        </b-modal>



        <!-- 官方發佈警特報內容 -->
        <b-modal hide-header-close ok-only size="md"
            :id="modalID" ref="modal"
            v-if="showAlertModal('Offical')"
            header-text-variant="light"
            :header-class="'stress-default stress_' + alert.status_code" >
            <!-- header -->
            <div slot="modal-header" v-html="getAlertModelTitle(alert)"></div>

            <!-- 警特報內容 -->
            <i :class="this.$tools.style.classStressIcon( this.alert.status_code, 'block-text' )"></i>警特報內容<br>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure 
            dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, 
            sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>


            <div slot="modal-footer" class="w-100">
                <div class="float-left">
                    <!-- HashTag -->
                    <i class="fa fa-hashtag"></i>
                    <div class="sensor-hashtag">中央氣象局</div>
                    
                </div>
                
                <b-btn size="md" :class="'btn-agri float-right btn-stress-' + alert.status_code" @click="closeModal()">
                {{ $t('menu.close') }}
                </b-btn>
            </div>
        </b-modal>
    </div>
</template>


<script>
import { mapState } from 'vuex'

export default {
    props: {
        alert: {
            type: Object,
            required: true,
        },
        timezone: { type: String },
        showType: {
            type: String,
            default: 'icon_text',
        },
        modalID: {
            type: String,
            required: true,
        },
        linkToDashboard: {
            type: Boolean,
            default: true,
        },
        queryHours: {
            type: Number,
            default: 24,
        },
    },
    computed:
    {
        ...mapState({
            'is_developer': state => state.user.is_developer,
            'user_admin': state => state.user.is_admin,
            'user_Project_List': state => state.project.projects,
        }),

        projID () {
            return this.alert.project_id
        },
        cpID () {
            return this.alert.cropperiod_id
        },

    },
    methods: {

        showAlertModal (type)
        {
            if (type == "Normal")
            {
                if (this.alert.status_code == 'G001') return false
                else if (this.alert.status_code == 'A001') return false
                else if (this.alert.status_code == 'S001') return false
                else if (this.alert.status_code[0] == 'T') return false
                return true
            }
            else if (type == "Offical")
            {
                if (this.alert.status_code[0] == 'T') return true
                return false
            }
        },

        getStressBtnClass ()
        {
            let _defaultClass = 'btn-stress btn-stress_';
            switch (this.showType)
            {
                case 'icon': return _defaultClass + this.alert.status_code + ' iconbutton';
                case 'icon_text': return _defaultClass + this.alert.status_code;
                default: return _defaultClass + this.alert.status_code;
            }
        },

        getStressBtnText ()
        {
            switch (this.showType)
            {
                case 'icon': return `<i class="${ this.$tools.style.classStressIcon( this.alert.status_code, 'no-text' ) }"></i>`;
                case 'icon_text': return `<i class="${ this.$tools.style.classStressIcon( this.alert.status_code, 'block-text' ) }"></i>${ this.$t('stress.' + this.alert.status_code) }`;
                default: return this.$t('stress.' + this.alert.status_code);
            }
        },

        getAlertModelTitle (alert)
        {
            let _alert_date = alert.log_info[0].log_time
            let _pastTime_Unit = 'minutes', _pastTime_showFloat = false;
            let _pastTime = this.$tools.date.countPastTime(_alert_date, undefined, _pastTime_Unit, _pastTime_showFloat, this.timezone);
            
            
            if (_pastTime >= 10080)  // 60 * 24 * 7 分鐘
            {
                _pastTime_Unit = 'weeks'; _pastTime_showFloat = true;
            }
            else if (_pastTime >= 1440)  // 60 * 24 分鐘
            {
                _pastTime_Unit = 'days'; _pastTime_showFloat = true;
            }
            else if (_pastTime >= 60)
            {
                _pastTime_Unit = 'hours'; _pastTime_showFloat = true;
            }
            _pastTime = this.$tools.date.countPastTime(_alert_date, undefined, _pastTime_Unit, _pastTime_showFloat, this.timezone);

            
            let _alert_date_count =  _pastTime + ' '  + this.$t('u.' + _pastTime_Unit + '_ago')

            return `<div style="display: inline-block; margin-right: 8px;">${ _alert_date }</div>
                    <div style="display: inline-block; margin-right: 8px;">${ this.$t('stress.' + alert.status_code) }</div>
                    <div style="display: inline-block; margin-right: 8px;">( ${ _alert_date_count } )</div>`
        },

        getCropperiodName () {
            let _theName = ''

            this.user_Project_List.forEach( _proj => {
                _proj.cropperiods.forEach( _cp => {
                    if (_cp.id == this.cpID)
                    {
                        _theName = _cp.name
                    }
                });
            });
            return _theName
        },

        closeModal ()
        {
            this.$refs.modal.hide()
        },

        goToPage (type, params, hash = undefined)
        {
            if (hash) hash = 'device-chart-block-' + hash;
            this.$router.push(this.$config.getPagesURL(type, params, hash));
        },


    },
    
}
</script>

<style lang="scss" scoped>
    
    .stress-history-title
    {
        display: inline-block;
        font-weight: 600;
        margin-right: 8px;
    }
    .stress-history-count
    {
        display: inline-block;
        font-size: 0.8rem;
        margin-right: 5px;
        padding: 1px 3px;
        color: #ffffff;
        background-color: #50c1f1; //#6fbd95;
        border-radius: 3px;
    }
    .stress-history-range
    {
        display: inline-block;
    }
    .stress-history-area
    {
        margin-bottom: 10px;
        font-size: 0.9rem;
        color: #657a7a;
        max-height: 150px;
        overflow-y: auto;

        .stress-history
        {
            display: inline-block;
            margin-left: 20px;
        }

        .stress-history-idx
        {
            display: inline-block;
            font-size: 0.8rem;
            margin-right: 5px;
            min-width: 15px;
            color: #50c1f1;
        }
        .stress-history-time
        {
            display: inline-block;
            // font-size: 0.8rem;
            margin-right: 5px;
        }
        .stress-history-device-id
        {
            display: inline-block;
            font-size: 0.7rem;
            margin-right: 5px;
            padding: 1px 3px;
            color: #ffffff;
            background-color: #595d59; //#6fbd95;
            border-radius: 3px;
        }
        .stress-history-device-name
        {
            display: inline-block;
        }
    }

    .stress-prevention-area
    {
        margin-bottom: 10px;
        padding: 2px 10px 2px 20px;
        // font-size: 0.9rem;
        color: #657a7a;
        max-height: 300px;
        overflow-y: auto;

        .stress-prevention-work
        {
            margin-bottom: 5px;
        }
        .stress-prevention-work-dividing-line
        {
            margin: 5px 0px;
        }
    }

    .stress-tag, .hashtag
    {
        display: inline-block;
    }
    .sensor-hashtag
    {
        display: inline-block;
        margin-right: 5px;
        color: #0fa1a1;
    }
    .modal-body p
    {
        margin-left: 20px;
    }
    .go-to-dashboard
    {
        display: inline-block;
        color: #0fa1a1;
    }

</style>
